import type { FaireProductEntity } from "../../entity_types/product";

export const p_1578krx0: FaireProductEntity = {
  token: "p_1578krx0",
  type: "product",
  name: "Glue Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1ce296f3281abc08a6ea37370b28c73b7d4eed066d0e58c805ddb0b512b03d60.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6f879c8b765a40beb1cd93525a1fe435eec6c25f7bf667ff17b54b95c1506e92/1528387494.png",
    "https://cdn.faire.com/fastly/f92e3394d2b3d52a104164a9b4db9ab88e8ed506ca7e528727fab87440e35c6b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:22.892Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
